import { render } from "./ExportfaBtn.vue?vue&type=template&id=4d51c76e&scoped=true"
const script = {}

import "./ExportfaBtn.vue?vue&type=style&index=0&id=4d51c76e&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d51c76e"]])

export default __exports__